import * as React from "react";
import {Party, PaymentCard, resourcesHelper} from "@falcon/services";
import {Link} from "react-router-dom";
import * as moment from "moment";

interface IProps {
    party: Party;
    mainCardId: string;
    policyNumber: string;
    annualMonthlyOptionCardExpired: boolean;
}

export class CardExpiryBanner extends React.Component<IProps> {

    public render() {
        return (
            <div id="cardExpiredBanner" className="banner">
                <img src={`/${resourcesHelper.THEME}/img/alert-red.svg`} alt="Red alert icon"/>
                <div className="banner-text font-weight-semi-bold">
                    {this.getCardExpiryWordingElement(this.findMainPaymentCard())}
                </div>
            </div>
        );
    }

    private readonly getCardExpiryWordingElement = (mainPaymentCard: PaymentCard): React.ReactNode => {
        let textElement: React.ReactNode = <></>;
        const cardNumberObfuscated: string = mainPaymentCard.cardNumberObfuscated.split('******')[1];
        const linkComponent: React.ReactNode =
            <Link to={`/dashboard/account/changeCard/${this.props.policyNumber}`} id="changeCard"
                  aria-label={"Please change your payment card."}>Please change your payment card.</Link>

        if (this.props.annualMonthlyOptionCardExpired) {
            textElement = <div id={"card-expired"}>
                Your card ending {cardNumberObfuscated} has expired.{' '}
                {linkComponent}
            </div>
        } else if (!this.props.annualMonthlyOptionCardExpired) {
            textElement = <div id={"card-about-to-expire"}>
                    Your Visa ending in {cardNumberObfuscated} will expire in{' '}
                    {moment.monthsShort(mainPaymentCard.expiryMonth - 1)} {mainPaymentCard.expiryYear}.{' '}
                    {linkComponent}
                </div>

        }

        return textElement;
    }

    private readonly findMainPaymentCard = (): PaymentCard => {
        for (const card of this.props.party.paymentCards) {
            if (this.isMainPaymentCard(card)) {
                return card;
            }
        }
        return this.props.party.paymentCards[0];
    }

    private readonly isMainPaymentCard = (card: PaymentCard) => {
        return this.props.mainCardId === card.id.toString();
    }
}
